import { defineAsyncComponent } from 'vue';

import { toPlugin, type ComponentType, type Plugin } from '@bv/helpers/components';

export { default as BvHeatmapChart } from './HeatMap/BvHeatmapChart.vue';
export { default as BvMetricList } from './metrics/BvMetricList.vue';
export { default as BvMetricItem } from './metrics/BvMetricItem.vue';
export { default as BvChartWrapper } from './partials/BvChartWrapper.vue';
export { default as BvPieChart } from './pie/BvPieChart.vue';
export { default as BvStackedChart } from './stacked/BvStackedChart.vue';
export { default as BvLineChart } from './Line/BvLineChart.vue';
export { default as BvBreakdownChart } from './breakdown/BvBreakdownChart.vue';
export { default as BvExportChart } from './partials/BvExportChart.vue';

export const chartsArray: ComponentType[] = [
  {
    name: 'BvHeatmapChart',
    component: defineAsyncComponent(() => import('@bv/components/charts/HeatMap/BvHeatmapChart.vue')),
  },
  {
    name: 'BvMetricList',
    component: defineAsyncComponent(() => import('@bv/components/charts/metrics/BvMetricList.vue')),
  },
  {
    name: 'BvMetricItem',
    component: defineAsyncComponent(() => import('@bv/components/charts/metrics/BvMetricItem.vue')),
  },
  {
    name: 'BvChartWrapper',
    component: defineAsyncComponent(() => import('@bv/components/charts/partials/BvChartWrapper.vue')),
  },
  {
    name: 'BvExportChart',
    component: defineAsyncComponent(() => import('@bv/components/charts/partials/BvExportChart.vue')),
  },
  {
    name: 'BvPieChart',
    component: defineAsyncComponent(() => import('@bv/components/charts/pie/BvPieChart.vue')),
  },
  {
    name: 'BvStackedChart',
    component: defineAsyncComponent(() => import('@bv/components/charts/stacked/BvStackedChart.vue')),
  },
  {
    name: 'BvLineChart',
    component: defineAsyncComponent(() => import('@bv/components/charts/Line/BvLineChart.vue')),
  },
  {
    name: 'BvBreakdownChart',
    component: defineAsyncComponent(() => import('@bv/components/charts/breakdown/BvBreakdownChart.vue')),
  },
];

export const charts: Plugin<[]> = toPlugin(chartsArray);
